import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import { Navigation, Pagination, Autoplay } from "swiper";

const imgs = [
  require("../assets/dutos.png"),
  require("../assets/dutos-01.png"),
  require("../assets/dutos-02.png"),
  require("../assets/dutos-03.png"),
];

export default () => {
  return (
    <>
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        width={462}
        spaceBetween={50}
        className="swiper-service"
        loop={true}
        autoplay={true}
        navigation={true}
      >
        <SwiperSlide key="slide1">
          <img src={imgs[1]} alt="Dutos Soldados" />
        </SwiperSlide>
        <SwiperSlide key="slide2">
          <img src={imgs[2]} alt="Dutos Soldados" />
        </SwiperSlide>
        <SwiperSlide key="slide3">
          <img src={imgs[3]} alt="Dutos Soldados" />
        </SwiperSlide>
      </Swiper>
      <div className="desc">
        <div className="text">
          <h1>Dutos soldados de inox</h1>
          <p>
            Dutos para fornos ou churrasqueiras, feito em inox com excelente
            acabamento e qualidade, que proporciona ótima resistência e
            durabilidade.
          </p>
        </div>
        <div className="photo">
          <img src={imgs[0]} alt="Dutos soldados" />
        </div>
      </div>
    </>
  );
};
